<template>
  <div>
    <btn-icon-tip
        :id="'selectFileBtn_' + Math.random().toString(36).substr(2, 9)"
        :icon="icon"
        :icon-color="color"
        :disabled="disabled"
        :tip="tip"
        @click="onIconClick" />
    <div class="hiddenFileInput">
      <input
          :id="Math.random().toString(36).substr(2, 9)"
          ref="fileInput"
          :multiple="multiple"
          :accept="accept"
          type="file"
          @change="onFileChange">
    </div>
  </div>
</template>

<style scoped>
  .hiddenFileInput {
    display: none;
  }
</style>

<script>
  import BtnIconTip from './BtnIconTip.vue'
  export default {
    components: {
      BtnIconTip
    },
    props: {
      value: {
        type: [Array, String]
      },
      accept: {
        type: String,
        default: '.xls,.xlt,.xla,.xlsx,.xltx,.xlsm,.xltm,.xlam,.xlsb,.doc,.dot,.docx,.dotx,.docm,.dotm,.pdf,.tif,.tiff,.jpeg,.jpg,.bmp,.png,.csv,.sig,.xml,.rar,.zip,.7z,.txt'
      },
      color: {
        type: String,
        default: 'addbtn'
      },
      icon: {
        type: String,
        default: 'attach_file'
      },
      tip: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      },
      multiple: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        maxFileSize: 52428800
      }
    },
    computed: {
      maxFileSizeError () {
        return this.$t('Максимальный размер загружаемых файлов 50 Мб')
      },
      displayTip () {
        return this.tip
          ? this.tip
          : this.multiple
            ? this.$t('Выбрать файлы')
            : this.$t('Выбрать файл')
      }
    },
    methods: {
      validateAndGet: function (files) {
        const forms = []
        for (const file of files) {
          if (file.size >= this.maxFileSize) {
            this.showErrorAction({
              message: this.maxFileSizeError
            })
          }
          if (file.size > 0) {
            forms.push({
              file,
              name: file.name,
              size: file.size,
              type: file.type
            })
          }
        }
        return forms
      },
      onIconClick: function () {
        if (!this.disabled) {
          this.clear()
          this.$refs.fileInput.click()
        }
      },
      clear: function () {
        // для очистки файлового инпута перед выбором нового файла (если не чистить то не срабатывает событие change для повторного выбора того же файла)
        this.$refs.fileInput.value = null
      },
      onFileChange: function ($event) {
        const files = this.validateAndGet($event.target.files || $event.dataTransfer.files)
        if (!files.length) {
          this.$emit('change', null)
        } else {
          this.$emit('change', this.multiple ? files : files[0])
        }
      }
    }
  }
</script>
